import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo">
          Andrew Sorensen
        </Link>
        <nav className="nav-desktop">
          <NavLink to="/about" className="nav-link">
            About Me
          </NavLink>
          <NavLink to="/skills" className="nav-link">
            Skills
          </NavLink>
          <NavLink to="/examples" className="nav-link">
            Examples
          </NavLink>
          <NavLink to="/contact" className="nav-link">
            Contact
          </NavLink>
        </nav>
        <div className="nav-mobile">
          <button 
            className="menu-button" 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            Menu
          </button>
          {isMenuOpen && (
            <div className="dropdown-menu">
              <NavLink to="/about" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                About Me
              </NavLink>
              <NavLink to="/skills" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                Skills
              </NavLink>
              <NavLink to="/examples" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                Examples
              </NavLink>
              <NavLink to="/contact" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                Contact
              </NavLink>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;